import React, { useEffect, useRef, useState } from 'react';
import { Form } from '@unform/web';
import { Row, Col, Button, Label } from 'reactstrap';
import { ValidationError } from 'yup';
import cep from 'cep-promise';
import Swal from 'sweetalert2';
import { toast } from 'react-toastify';
import 'suneditor/dist/css/suneditor.min.css';
import { useField } from '@unform/core';
import SunEditorComponent from 'suneditor-react';

import AsyncSelect from '../../../components/AsyncSelect';
import MaskedInput from '../../../components/unformMaskedInput';
import InputUnform from '../../../components/unformInput';
import UnformRadio from '../../../components/unformRadio';

import formatCEP from '../../../utils/formatCEP';
import formatDate from '../../../utils/formatDate';
import formatCPF from '../../../utils/formatCPF';
import formatCNPJ from '../../../utils/formatCNPJ';

import api from '../../../services/api';

import {
  cepMask,
  telefoneCelularMask,
  cpfMask,
  cnpjMask,
  dateMask,
} from '../../../utils/masks';

import alteraPFvalidator from '../../../validations/alteraDataAdmPFValidator';
import alteraPJParceiroValidator from '../../../validations/alteraDataAdmPJValidatorParceiro';
import alteraPJRevendedorValidator from '../../../validations/alteraDataAdmPJValidatorRevendedor';
import alteraPJClienteValidator from '../../../validations/alterarClientePjAdm';

import convertStringDate from '../../../utils/convertStringDate';
import { useHistory } from 'react-router-dom';

let ultimoCep = '';

const swalWithBootstrapButtons = Swal.mixin({
  customClass: {
    confirmButton: 'ml-3 btn btn-success',
    cancelButton: 'btn btn-danger',
  },
  buttonsStyling: false,
});

function AlterarDadosAdm(props) {
  const { tipo: tipoUser, id } = props.match.params;
  const formRef = useRef(null);
  const checkboxRef = useRef(null);
  let timeoutConsulta;
  let timeoutConsultaParceiro;

  const [cliente, setClient] = useState(null);
  const [tipoPessoa, setTipoPessoa] = useState('PF');
  const [disabled, setDisabled] = useState(true);
  const history = useHistory();

  const [representante, setRepresentante] = useState(false);

  const [marcaParceiro, setMarcaParceiro] = useState(null);
  const [parceiro, setParceiro] = useState(null);
  const [terceiro, setTerceiro] = useState(null);
  const [image, setImage] = useState(null);
  const [imageHasChanged, setImageHasChanged] = useState(false);

  const [erroMarca, setErroMarca] = useState(false);
  const [erroImagem, serErroImagem] = useState(false);
  const [erroPercentual, setErroPercentual] = useState(false);

  const [imageParceiro1, setImageParceiro1] = useState(null);
  const [imageParceiro1Bool, setImageParceiro1Bool] = useState(false);
  const [imageParceiro2, setImageParceiro2] = useState(null);
  const [imageParceiro2Bool, setImageParceiro2Bool] = useState(false);
  const [imageParceiro3, setImageParceiro3] = useState(null);
  const [imageParceiro3Bool, setImageParceiro3Bool] = useState(null);

  const [imgId1, setId1] = useState(null);
  const [imgId2, setId2] = useState(null);
  const [imgId3, setId3] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    async function getData(id, tipoPessoa) {
      Swal.fire({
        title: 'Aguarde',
        allowOutsideClick: false,
        showConfirmButton: false,
        onBeforeOpen: () => {
          Swal.showLoading();
        },
      });
      try {
        let dados;

        if (tipoUser.includes('cliente')) {
          const { data } = await api.get(`/client-data/${id}/${tipoPessoa}`);
          dados = data;
        } else if (tipoUser === 'parceiros') {
          const { data } = await api.get(`/parceiro-data/${id}`);
          dados = data;
          dados?.sobre_estabelecimento &&
            formRef.current.setFieldValue(
              'sobre_estabelecimento',
              dados?.sobre_estabelecimento
            );
          dados?.regras_utilizacao &&
            formRef.current.setFieldValue(
              'regras_utilizacao',
              dados?.regras_utilizacao
            );
          if (dados.imagem) {
            setImage(dados.imagem.url);
            setImageParceiro1(dados.imagem_parceiro_1_id?.url);
            setId1({
              id: data?.imagem_parceiro_1_id?.id,
              campo: 'imagem_parceiro_1',
              number: 1,
              edited: !data?.imagem_parceiro_1_id?.url ? true : false,
            });
            setImageParceiro2(dados.imagem_parceiro_2_id?.url);
            setId2({
              id: data?.imagem_parceiro_2_id?.id,
              campo: 'imagem_parceiro_2',
              number: 2,
              edited: !data?.imagem_parceiro_2_id?.url ? true : false,
            });
            setImageParceiro3(dados.imagem_parceiro_3_id?.url);
            setId3({
              id: data?.imagem_parceiro_3_id?.id,
              campo: 'imagem_parceiro_3',
              number: 3,
              edited: !data?.imagem_parceiro_3_id?.id ? true : false,
            });
            setMarcaParceiro({
              value: dados.marca.id,
              nome: dados.marca.nome,
            });
            if (dados.representante) {
              setRepresentante(true);
            } else {
              setRepresentante(false);
            }
          }
        } else if (tipoUser === 'revendedores') {
          const { data } = await api.get(`/revendedor-data/${id}`);
          dados = data;
        }

        if (dados) {
          if (dados.responsavel) {
            setParceiro(dados.responsavel);
          } else {
            setParceiro(null);
          }
          setTerceiro(dados.superior);
          setClient(dados);
          setDisabled(false);
          Swal.close();
        } else {
          toast.error('Não existem dados para serem apresentados');
          setDisabled(true);
          Swal.close();
        }
      } catch (e) {
        Swal.close();
        setDisabled(true);
        toast.error('Não foi possível carregar os dados');
      }
    }

    let tipoP;
    if (tipoUser === 'parceiros') {
      setTipoPessoa('PJ');
      tipoP = 'PJ';
    } else if (tipoUser === 'revendedores') {
      setTipoPessoa('PJ');
      tipoP = 'PJ';
    } else if (tipoUser === 'clientes_pj') {
      setTipoPessoa('PJ');
      tipoP = 'PJ';
    } else {
      setTipoPessoa('PF');
      tipoP = 'PF';
    }

    getData(id, tipoP);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function handleSubmit(data) {
    // console.log(data.cep);
    formRef.current.setErrors([]);
    try {
      Swal.fire({
        title: 'Aguarde',
        allowOutsideClick: false,
        showConfirmButton: false,
        onBeforeOpen: () => {
          Swal.showLoading();
        },
      });

      let body;

      if (tipoPessoa === 'PF') {
        await alteraPFvalidator(data);
        body = {
          id: cliente.id,
          idUser: cliente.idUser,
          nome: data.nome_completo,
          cpf: Number(data.cpf),
          data_nascimento: convertStringDate(data.data_nasc),
          cep: data.cep,
          logradouro: data.endereco,
          numero: data.numero,
          bairro: data.bairro,
          cidade: data.cidade,
          estado: data.estado,
          complemento: data.complemento,
          email: data.email,
          telefone_celular: Number(data.celular),
          telefone_residencial: Number(data.telefone),
          tipo: tipoPessoa,
        };
        await api.patch(`/alterar-dados-cliente`, body);
      } else if (tipoPessoa === 'PJ') {
        if (tipoUser === 'parceiros') {
          serErroImagem(false);
          setErroPercentual(false);
          setErroMarca(false);
          await alteraPJParceiroValidator(data);
          if (!marcaParceiro) {
            setErroMarca(true);
          } else {
            data.marca_id = marcaParceiro.value;
          }
          if (!image) {
            serErroImagem(true);
          }

          if (
            (representante === true && data.percentual === null) ||
            (representante === true && data.percentual === '')
          ) {
            formRef.current.setErrors({ percentual: 'Obrigatório' });
            setErroPercentual(true);
          }

          if (
            erroPercentual === false &&
            erroMarca === false &&
            erroImagem === false
          ) {
            var formData = new FormData();
            if (imageHasChanged && image) {
              image && formData.append('files', image, 'imagem_id');
            }
            if (imgId1?.edited || imageParceiro1Bool) {
              imageParceiro1 &&
                formData.append('files', imageParceiro1, 'imagem_parceiro_1');
            }
            if (imgId2?.edited || imageParceiro2Bool) {
              imageParceiro2 &&
                formData.append('files', imageParceiro2, 'imagem_parceiro_2');
            }
            if (imgId3?.edited || imageParceiro3Bool) {
              imageParceiro3 &&
                formData.append('files', imageParceiro3, 'imagem_parceiro_3');
            }
            try {
              const { data: fotos_salvas } = await api.post(
                '/imagens-multi',
                formData
              );
              fotos_salvas.forEach((foto) => {
                data[foto.field] = foto.id;
              });
            } catch (e) {
              toast.error('Erro ao salvar imagem!');
            }

            body = {
              id: cliente.id,
              idUser: cliente.idUser,
              razao_social: data.razao_social,
              nome_fantasia: data.nome_fantasia,
              cnpj: Number(data.cnpj),
              nome_responsavel: data.nome_responsavel,
              cep: data.cep,
              logradouro: data.endereco,
              numero: data.numero,
              bairro: data.bairro,
              cidade: data.cidade,
              estado: data.estado,
              complemento: data.complemento,
              email: data.email,
              telefone_celular: Number(data.celular),
              telefone_comercial: Number(data.telefone),
              tipo: tipoPessoa,
              perfil: tipoUser,
              representante: representante,
              percentual: data.percentual ? data.percentual : null,
              imagem_id: data.imagem_id,
              longitude: data.longitude,
              latitude: data.latitude,
              descricao: data.descricao,
              subtitulo: data.subtitulo,
              beneficio: data.beneficio,

              porcentagem_venda: data.porcentagem_venda
                ? data.porcentagem_venda
                : null,

              imagem_parceiro_1: data.imagem_parceiro_1,
              imagem_parceiro_2: data.imagem_parceiro_2,
              imagem_parceiro_3: data.imagem_parceiro_3,

              linkedin: data.linkedin,
              instagram: data.instagram,
              facebook: data.facebook,

              sobre_estabelecimento: data.sobre_estabelecimento,
              regras_utilizacao: data.regras_utilizacao,
              website: data.website,
            };
            if (parceiro?.value) {
              if (data.superior !== 'poupa') {
                body.responsavel = parceiro?.value;
              } else {
                body.responsavel = null;
              }
            }

            await api.patch(`/parceiro`, body);
          } else {
            toast.error('Verifique os campos em vermelho!');
          }
        } else if (tipoUser === 'revendedores') {
          await alteraPJRevendedorValidator(data);
          body = {
            id: cliente.id,
            idUser: cliente.idUser,
            razao_social: data.razao_social,
            nome_fantasia: data.nome_fantasia,
            cnpj: Number(data.cnpj),
            nome_responsavel: data.nome_responsavel,
            cep: data.cep,
            logradouro: data.endereco,
            numero: data.numero,
            bairro: data.bairro,
            cidade: data.cidade,
            estado: data.estado,
            complemento: data.complemento,
            email: data.email,
            telefone_celular: Number(data.celular),
            telefone_comercial: Number(data.telefone),
            tipo: tipoPessoa,
            perfil: tipoUser,
            percentual: data.percentual,
            superior: data.superior,

            porcentagem_venda: data.porcentagem_venda
              ? data.porcentagem_venda
              : null,
          };
          if (parceiro?.value) {
            if (data.superior !== 'poupa') {
              body.responsavel = parceiro?.value;
            } else {
              body.responsavel = null;
            }
          }
          await api.patch(`/revendedor`, body);
        } else if (tipoUser === 'clientes_pj') {
          await alteraPJClienteValidator(data);
          body = {
            id: cliente.id,
            idUser: cliente.idUser,
            razao_social: data.razao_social,
            nome_fantasia: data.nome_fantasia,
            cnpj: Number(data.cnpj),
            responsavel: data.nome_responsavel,
            cep: data.cep,
            logradouro: data.endereco,
            numero: data.numero,
            bairro: data.bairro,
            cidade: data.cidade,
            estado: data.estado,
            complemento: data.complemento,
            email: data.email,
            telefone_celular: Number(data.celular),
            telefone_comercial: Number(data.telefone),
            tipo: tipoPessoa,
            perfil: tipoUser,
          };
          if (parceiro?.value) {
            body.responsavel_whitelabel = parceiro?.value;
          }
          await api.patch(`/alterar-dados-cliente`, body);
        }
      }

      Swal.close();
      const url = tipoUser.includes('clientes')
        ? '/acesso/'
        : '/acesso/consulta-todos/';
      history.push(url + tipoUser);
      toast.success('Dados alterados com sucesso');
    } catch (err) {
      // console.log(err);
      const validationErrors = {};
      Swal.close();
      if (err instanceof ValidationError) {
        err.inner.forEach((error) => {
          validationErrors[error.path] = error.message;
        });
        formRef.current.setErrors(validationErrors);
        toast.error('Verifique os campos em vermelho!');
        setTimeout(() => {
          window.scrollTo(0, 0);
        }, 800);
      } else {
        const error =
          err?.response?.data?.error || 'Ocorreu um erro, tente novamente!';
        toast.error(error);
      }
    }
  }

  async function buscaCep(cepValue) {
    if (cepValue) {
      if (ultimoCep !== cepValue) {
        try {
          if (cepValue?.replaceAll('_', '')?.length === 9) {
            const result = await cep(cepValue);

            formRef.current.setData({
              ...formRef.current.getData(),
              bairro: result.neighborhood,
              cidade: result.city,
              estado: result.state,
              endereco: result.street,
            });
            ultimoCep = cepValue;
          } else if (cepValue?.length === 0) {
            formRef.current.setData({
              ...formRef.current.getData(),
              bairro: '',
              cidade: '',
              estado: '',
              endereco: '',
            });
          }
        } catch (error) {
          formRef.current.setData({
            ...formRef.current.getData(),
            bairro: '',
            cidade: '',
            estado: '',
            endereco: '',
          });
          toast.warn('CEP não encontrado!');
        }
      }
    }
  }

  const debounceConsulta = async (body) => {
    return await new Promise((resolve) => {
      clearTimeout(timeoutConsulta);

      timeoutConsulta = setTimeout(() => {
        resolve(filtrarConsulta(body));
      }, 500);
    });
  };

  const debounceConsultaParceiro = async (body) => {
    return await new Promise((resolve) => {
      clearTimeout(timeoutConsultaParceiro);

      timeoutConsultaParceiro = setTimeout(() => {
        resolve(filtrarParceiro(body));
      }, 500);
    });
  };

  async function filtrarConsulta({ value, param }) {
    if (tipoPessoa === 'PF') {
      const result = await api.get(`options/clientes?${param}=${value}`);
      return result.data.map((cliente) => ({
        value: cliente.id,
        cpf: cliente.cpf,
        nome: cliente.nome,
      }));
    } else if (tipoPessoa === 'PJ') {
      if (tipoUser === 'parceiros') {
        const result = await api.get(`options/parceiros?${param}=${value}`);
        return result.data.map((parceiro) => ({
          value: parceiro.id,
          cnpj: parceiro.cnpj,
          nome: parceiro.nome,
        }));
      } else if (tipoUser === 'revendedores') {
        const result = await api.get(`options/revendedores?${param}=${value}`);
        return result.data.map((revendedor) => ({
          value: revendedor.id,
          cnpj: revendedor.cnpj,
          nome: revendedor.nome,
        }));
      }
    }
  }

  async function filtrarParceiro({ value, param }) {
    const result = await api.get(`options/whitelabel?${param}=${value}`);
    return result.data.map((parceiro) => ({
      value: parceiro.id,
      nome: parceiro.nome,
    }));
  }

  function useDisplayImage() {
    const [result, setResult] = React.useState('');

    function uploader(e) {
      if (e.target.files[0]) {
        setResult(`url(${URL.createObjectURL(e.target.files[0])})`);
      } else {
        setResult(null);
      }
      setImageHasChanged(true);
    }
    return { result, uploader };
  }

  const { result, uploader } = useDisplayImage();

  async function deleteImage(item) {
    // console.log(item);
    swalWithBootstrapButtons
      .fire({
        title: `Tem certeza que deseja excluir esta imagem?`,
        text: 'Esta operação não poderá ser revertida!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
        reverseButtons: true,
      })
      .then((result) => {
        if (result.value) {
          Swal.fire({
            title: 'Aguarde',
            allowOutsideClick: false,
            showConfirmButton: false,
            onBeforeOpen: () => {
              Swal.showLoading();
            },
          });
          api
            .delete(`delete-parceiro-imagem/${item.id}`, {
              data: {
                parceiro: cliente?.id,
                campo: item?.campo,
              },
            })
            .then(() => {
              Swal.close();
              toast.success('Excluido com sucesso');
              switch (Number(item.number)) {
                case 1:
                  setImageParceiro1(null);
                  setId1({ ...imgId1, edited: true });
                  break;
                case 2:
                  setImageParceiro2(null);
                  setId2({ ...imgId2, edited: true });
                  break;
                case 3:
                  setImageParceiro3(null);
                  setId3({ ...imgId3, edited: true });
                  break;

                default:
                  break;
              }
            })
            .catch((error) => {
              const msg =
                error?.response?.data?.error ||
                'Ocorreu um erro, tente novamente mais tarde!';
              swalWithBootstrapButtons.fire('Ops...', msg, 'error');
            });
        }
      });
  }

  return (
    <>
      <Row>
        <Col lg={7}>
          <h5 className='txt-tertiary'>Alterar dados cadastrais</h5>
        </Col>
      </Row>
      <div className='card-form'>
        <Form
          onSubmit={(data) => {
            handleSubmit(data);
          }}
          ref={formRef}
        >
          <Row>
            {tipoPessoa === 'PF' && (
              <Col lg={12}>
                <span className='placholder-top'>Nome completo</span>
                <InputUnform
                  placeholder=''
                  type='text'
                  name='nome_completo'
                  className='input-field-inner'
                  defaultValue={cliente && (cliente.nome ? cliente.nome : '')}
                  disabled={disabled}
                />
              </Col>
            )}
            {tipoPessoa === 'PJ' && (
              <>
                <Col lg={7}>
                  <span className='placholder-top'>Razão social</span>
                  <InputUnform
                    placeholder=''
                    type='text'
                    name='razao_social'
                    className='input-field-inner'
                    defaultValue={
                      cliente &&
                      (cliente.razao_social ? cliente.razao_social : '')
                    }
                    disabled={disabled}
                  />
                </Col>
                <Col lg={5}>
                  <span className='placholder-top'>Nome fantasia</span>
                  <InputUnform
                    placeholder=''
                    type='text'
                    name='nome_fantasia'
                    className='input-field-inner'
                    defaultValue={
                      cliente &&
                      (cliente.nome_fantasia ? cliente.nome_fantasia : '')
                    }
                    disabled={disabled}
                  />
                </Col>
              </>
            )}
          </Row>
          <Row>
            {tipoPessoa === 'PF' && (
              <>
                <Col lg={4}>
                  <span className='placholder-top'>CPF</span>
                  <MaskedInput
                    className='input-field-inner'
                    type='text'
                    mask={cpfMask}
                    removeEspecial
                    name='cpf'
                    value={
                      cliente &&
                      (cliente.cpf
                        ? formatCPF(`00000000000${cliente.cpf}`.slice(-11))
                        : '')
                    }
                    disabled={disabled}
                  />
                </Col>

                <Col lg={4}>
                  <span className='placholder-top'>Data de nascimento</span>
                  <MaskedInput
                    type='text'
                    className='input-field-inner'
                    mask={dateMask}
                    name='data_nasc'
                    value={
                      cliente &&
                      (cliente.nascimento ? formatDate(cliente.nascimento) : '')
                    }
                    disabled={disabled}
                  />
                </Col>

                <Col lg={4} sm={12}>
                  <span className='placholder-top'>Responsável</span>
                  <AsyncSelect
                    loadOptions={(value) =>
                      debounceConsultaParceiro({
                        value,
                        param: 'nome',
                      })
                    }
                    isDisabled
                    name='responsavel'
                    getOptionLabel={(option) => option.nome}
                    onChange={setParceiro}
                    value={parceiro}
                    cacheOptions
                    isClearable
                    placeholder={'Parceiro WhiteLabel'}
                    noOptionsMessage={() => 'Digite para pesquisar'}
                  />
                </Col>
              </>
            )}
            {tipoPessoa === 'PJ' &&
              (tipoUser !== 'clientes_pj' ? (
                <>
                  <Col lg={5}>
                    <span className='placholder-top'>CNPJ</span>
                    <MaskedInput
                      className='input-field-inner'
                      type='text'
                      mask={cnpjMask}
                      removeEspecial
                      name='cnpj'
                      value={
                        cliente &&
                        (cliente.cnpj
                          ? formatCNPJ(
                              `00000000000000${cliente?.cnpj}`.slice(-14)
                            )
                          : '')
                      }
                      disabled={disabled}
                    />
                  </Col>
                  <Col lg={7}>
                    <span className='placholder-top'>Nome do responsável</span>
                    <InputUnform
                      type='text'
                      name='nome_responsavel'
                      className='input-field-inner'
                      defaultValue={
                        cliente &&
                        (cliente.nome_responsavel
                          ? cliente.nome_responsavel
                          : '')
                      }
                      disabled={disabled}
                    />
                  </Col>
                </>
              ) : (
                <>
                  <Col lg={4}>
                    <span className='placholder-top'>CNPJ</span>
                    <MaskedInput
                      className='input-field-inner'
                      type='text'
                      mask={cnpjMask}
                      removeEspecial
                      name='cnpj'
                      value={
                        cliente &&
                        (cliente.cnpj
                          ? formatCNPJ(
                              `00000000000000${cliente?.cnpj}`.slice(-14)
                            )
                          : '')
                      }
                      disabled={disabled}
                    />
                  </Col>
                  <Col lg={4}>
                    <span className='placholder-top'>Nome do responsável</span>
                    <InputUnform
                      type='text'
                      name='nome_responsavel'
                      className='input-field-inner'
                      defaultValue={
                        cliente &&
                        (cliente.nome_responsavel
                          ? cliente.nome_responsavel
                          : '')
                      }
                      disabled={disabled}
                    />
                  </Col>
                  <Col lg={4} sm={12}>
                    <span className='placholder-top'>Responsável</span>
                    <AsyncSelect
                      isDisabled={disabled}
                      loadOptions={(value) =>
                        debounceConsultaParceiro({
                          value,
                          param: 'nome',
                        })
                      }
                      name='responsavel'
                      getOptionLabel={(option) => option.nome}
                      onChange={setParceiro}
                      value={parceiro}
                      cacheOptions
                      isClearable
                      placeholder={'Parceiro WhiteLabel'}
                      noOptionsMessage={() => 'Digite para pesquisar'}
                    />
                  </Col>
                </>
              ))}
          </Row>
          {tipoPessoa === 'PJ' && tipoUser !== 'clientes_pj' && (
            <Row>
              {tipoUser === 'parceiros' ? (
                <>
                  <Col lg={1} sm={4} xs={6} className='mr-2'>
                    <span className='placholder-top mb-2'>Representante</span>
                    <br />
                    <label className='switch'>
                      <input
                        disabled={disabled}
                        ref={checkboxRef}
                        name='representante'
                        type='checkbox'
                        onChange={(e) => {
                          setRepresentante(!representante);
                        }}
                        checked={representante}
                      />
                      <span className='slider round'></span>
                    </label>
                  </Col>
                  <Col lg={3} sm={6} xs={6} hidden={!representante}>
                    <span className='placholder-top mb-2'>
                      % Participação venda direta
                    </span>
                    <InputUnform
                      type='number'
                      min={1}
                      max={100}
                      step='0.1'
                      name='percentual'
                      className='input-field-inner'
                      // defaultValue={1}
                      defaultValue={
                        cliente &&
                        (cliente.percentual_participacao
                          ? cliente.percentual_participacao
                          : '')
                      }
                    />
                  </Col>

                  <Col lg={3} sm={6} xs={6} hidden={!representante}>
                    <span className='placholder-top mb-2'>
                      % de participação split
                    </span>
                    <InputUnform
                      disabled={disabled}
                      type='number'
                      min={1}
                      max={100}
                      step='0.01'
                      name='porcentagem_venda'
                      className='input-field-inner'
                      defaultValue={
                        cliente &&
                        (cliente.porcentagem_venda
                          ? cliente.porcentagem_venda
                          : '')
                      }
                    />
                  </Col>
                </>
              ) : (
                <>
                  <Col lg={3} sm={6} xs={6}>
                    <span className='placholder-top mb-2'>
                    % Participação venda direta
                    </span>
                    <InputUnform
                      disabled={disabled}
                      type='number'
                      min={1}
                      max={100}
                      step='0.01'
                      name='percentual'
                      className='input-field-inner'
                      defaultValue={
                        cliente &&
                        (cliente.percentual_participacao
                          ? cliente.percentual_participacao
                          : '')
                      }
                    />
                  </Col>

                  <Col lg={3} sm={6} xs={6}>
                    <span className='placholder-top mb-2'>
                      % de participação split
                    </span>
                    <InputUnform
                      disabled={disabled}
                      type='number'
                      min={1}
                      max={100}
                      step='0.01'
                      name='porcentagem_venda'
                      className='input-field-inner'
                      defaultValue={
                        cliente &&
                        (cliente.porcentagem_venda
                          ? cliente.porcentagem_venda
                          : '')
                      }
                    />
                  </Col>
                  <Col lg={3} sm={6} xs={6}>
                    <label className='placholder-top w-100 mb-0'>
                      Superior
                    </label>
                    <div>
                      <UnformRadio
                        name='superior'
                        options={[
                          {
                            id: 'poupa',
                            value: 'poupa',
                            label: 'PoupaClub',
                          },
                          {
                            id: 'terceiro',
                            value: 'terceiro',
                            label: 'Terceiro',
                          },
                        ]}
                        disabled={disabled}
                        onChange={(e) => setTerceiro(e.target.value)}
                        defaultChecked={cliente?.superior}
                        optionsClass='mr-3'
                      />
                    </div>
                  </Col>
                </>
              )}

              <Col
                lg={3}
                sm={12}
                hidden={tipoUser === 'revendedores' && terceiro !== 'terceiro'}
              >
                <span className='placholder-top'>Responsável</span>
                <AsyncSelect
                  isDisabled={disabled}
                  loadOptions={(value) =>
                    debounceConsultaParceiro({
                      value,
                      param: 'nome',
                    })
                  }
                  name='responsavel'
                  getOptionLabel={(option) => option.nome}
                  onChange={setParceiro}
                  value={parceiro}
                  cacheOptions
                  isClearable
                  placeholder={'Parceiro WhiteLabel'}
                  noOptionsMessage={() => 'Digite para pesquisar'}
                />
              </Col>
            </Row>
          )}
          <Row>
            <Col lg={5}>
              <span className='placholder-top'>CEP</span>
              <MaskedInput
                className='input-field-inner'
                mask={cepMask}
                removeEspecial
                name='cep'
                value={
                  cliente &&
                  (cliente.cep
                    ? formatCEP(`00000000${cliente.cep}`.slice(-8))
                    : '')
                }
                onChange={(e) => {
                  buscaCep(e.target.value);
                }}
                disabled={disabled}
              />
            </Col>
          </Row>
          <Row>
            <Col lg={7}>
              <span className='placholder-top'>Endereço</span>
              <InputUnform
                placeholder=''
                type='text'
                name='endereco'
                className='input-field-inner'
                defaultValue={
                  cliente && (cliente.logradouro ? cliente.logradouro : '')
                }
                disabled={disabled}
              />
            </Col>
            <Col lg={2}>
              <span className='placholder-top'>Nº</span>
              <InputUnform
                placeholder=''
                type='text'
                name='numero'
                className='input-field-inner'
                defaultValue={cliente && (cliente.numero ? cliente.numero : '')}
                disabled={disabled}
              />
            </Col>
            <Col lg={3}>
              <span className='placholder-top'>Complemento</span>
              <InputUnform
                placeholder=''
                type='text'
                name='complemento'
                className='input-field-inner'
                defaultValue={
                  cliente && (cliente.complemento ? cliente.complemento : '')
                }
                disabled={disabled}
              />
            </Col>
          </Row>
          <Row>
            <Col lg={5}>
              <span className='placholder-top'>Bairro</span>
              <InputUnform
                placeholder=''
                type='text'
                name='bairro'
                className='input-field-inner'
                defaultValue={cliente && (cliente.bairro ? cliente.bairro : '')}
                disabled={disabled}
              />
            </Col>
            <Col lg={5}>
              <span className='placholder-top'>Cidade</span>
              <InputUnform
                placeholder=''
                type='text'
                name='cidade'
                className='input-field-inner'
                defaultValue={cliente && (cliente.cidade ? cliente.cidade : '')}
                disabled={disabled}
              />
            </Col>
            <Col lg={2}>
              <span className='placholder-top'>Estado</span>
              <InputUnform
                placeholder=''
                type='text'
                name='estado'
                className='input-field-inner'
                defaultValue={cliente && (cliente.estado ? cliente.estado : '')}
                disabled={disabled}
              />
            </Col>
          </Row>
          {tipoPessoa === 'PJ' && tipoUser === 'parceiros' && (
            <Row>
              <Col lg={4}>
                <span className='placholder-top'>Latitude</span>
                <InputUnform
                  placeholder=''
                  type='text'
                  name='latitude'
                  className='input-field-inner'
                  defaultValue={
                    cliente && (cliente?.latitude ? cliente?.latitude : '')
                  }
                  disabled={disabled}
                />
              </Col>
              <Col lg={4}>
                <span className='placholder-top'>Longitude</span>
                <InputUnform
                  placeholder=''
                  type='text'
                  name='longitude'
                  className='input-field-inner'
                  defaultValue={
                    cliente && (cliente?.longitude ? cliente?.longitude : '')
                  }
                  disabled={disabled}
                />
              </Col>
              <Col lg={4}>
                <span className='placholder-top'>Website</span>
                <InputUnform
                  placeholder=''
                  type='text'
                  name='website'
                  className='input-field-inner'
                  defaultValue={cliente?.website || ''}
                  disabled={disabled}
                />
              </Col>
            </Row>
          )}
          <Row>
            <Col lg={5}>
              <span className='placholder-top'>E-mail</span>
              <InputUnform
                placeholder=''
                type='text'
                name='email'
                className='input-field-inner'
                defaultValue={cliente && (cliente.email ? cliente.email : '')}
                disabled={disabled}
              />
            </Col>
          </Row>
          <Row>
            <Col lg={5}>
              <span className='placholder-top'>Celular</span>
              <MaskedInput
                placeholder=''
                className='input-field-inner'
                name='celular'
                mask={telefoneCelularMask}
                removeEspecial
                value={cliente && (cliente.celular ? cliente.celular : '')}
                disabled={disabled}
              />
            </Col>
            {tipoPessoa === 'PF' && (
              <Col lg={5}>
                <span className='placholder-top'>Residencial</span>
                <MaskedInput
                  className='input-field-inner'
                  name='telefone'
                  mask={telefoneCelularMask}
                  removeEspecial
                  value={cliente && (cliente.fixo ? cliente.fixo : '')}
                  disabled={disabled}
                />
              </Col>
            )}
            {tipoPessoa === 'PJ' && (
              <Col lg={5}>
                <span className='placholder-top'>Comercial</span>
                <MaskedInput
                  className='input-field-inner'
                  name='telefone'
                  mask={telefoneCelularMask}
                  removeEspecial
                  value={
                    cliente &&
                    (cliente.telefone_comercial
                      ? cliente.telefone_comercial
                      : '')
                  }
                  disabled={disabled}
                />
              </Col>
            )}
          </Row>
          {tipoPessoa === 'PJ' && tipoUser === 'parceiros' && (
            <Row>
              <Col lg={4}>
                <span className='placholder-top'>Facebook</span>
                <InputUnform
                  placeholder=''
                  className='input-field-inner'
                  name='facebook'
                  removeEspecial
                  defaultValue={
                    cliente && (cliente.facebook ? cliente.facebook : '')
                  }
                  disabled={disabled}
                />
              </Col>
              <Col lg={4}>
                <span className='placholder-top'>Instagram</span>
                <InputUnform
                  className='input-field-inner'
                  name='instagram'
                  removeEspecial
                  defaultValue={
                    cliente && (cliente.instagram ? cliente.instagram : '')
                  }
                  disabled={disabled}
                />
              </Col>
              <Col lg={4}>
                <span className='placholder-top'>LinkedIn</span>
                <InputUnform
                  className='input-field-inner'
                  name='linkedin'
                  removeEspecial
                  defaultValue={
                    cliente && (cliente.linkedin ? cliente.linkedin : '')
                  }
                  disabled={disabled}
                />
              </Col>
            </Row>
          )}
          {tipoPessoa === 'PJ' && tipoUser === 'parceiros' && (
            <>
              <hr />
              <Row>
                <Col lg={4}>
                  <span className='placholder-top'>
                    Imagem - Tamanho máximo 1MB
                  </span>
                  <div class='avatar-upload'>
                    <div class='avatar-edit'>
                      <input
                        disabled={disabled}
                        type='file'
                        id='imageUpload'
                        accept='.png, .jpg, .jpeg'
                        onChange={(e) => {
                          if (e.target.files[0]?.size > 1000000) {
                            setImage(null);
                            toast.error(
                              'Imagem deve conter tamanho máximo de 1MB'
                            );
                          } else {
                            setImage(e.target.files[0]);
                            uploader(e);
                          }
                        }}
                      />
                      <label for='imageUpload'></label>
                    </div>
                    <label class='avatar-preview' for='imageUpload'>
                      <div
                        id='imagePreview'
                        style={{
                          background:
                            imageHasChanged && result
                              ? result
                              : image
                              ? `url(${image})`
                              : 'url(data:image/png;base64,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)',
                        }}
                      ></div>
                    </label>
                  </div>
                  {erroImagem && <small className='error'>Obrigatório</small>}
                </Col>
                <Col lg={8}>
                  <span className='placholder-top'>Imagens do parceiro</span>
                  <Row>
                    <div class='avatar-upload-3'>
                      <div class='avatar-edit mb-2'>
                        {imageParceiro1 && !imgId1?.edited ? (
                          <Button
                            color='danger'
                            className='btn-pill btn-block mt-1'
                            onClick={() => deleteImage(imgId1)}
                          >
                            Excluir imagem
                          </Button>
                        ) : (
                          <input
                            type='file'
                            id='imagem_parceiro_1'
                            accept='.png, .jpg, .jpeg'
                            onChange={(e) => {
                              if (e.target.files[0]?.size > 1572864) {
                                setImageParceiro1(null);
                                setImageParceiro1Bool(false);
                                toast.error(
                                  'Imagem deve conter tamanho máximo de 1,5MB'
                                );
                              } else {
                                setImageParceiro1(e.target.files[0]);
                                setImageParceiro1Bool(true);
                              }
                            }}
                          />
                        )}
                        <label for='imagem_parceiro_1'></label>
                      </div>
                      <Label
                        style={{ color: 'green' }}
                        hidden={!imageParceiro1Bool}
                      >
                        Selecionado
                      </Label>
                    </div>
                    <div class='avatar-upload-3'>
                      <div class='avatar-edit mb-2'>
                        {imageParceiro2 && !imgId2?.edited ? (
                          <Button
                            color='danger'
                            className='btn-pill btn-block mt-1'
                            onClick={() => deleteImage(imgId2)}
                          >
                            Excluir imagem
                          </Button>
                        ) : (
                          <input
                            type='file'
                            id='imagem_parceiro_2'
                            accept='.png, .jpg, .jpeg'
                            onChange={(e) => {
                              if (e.target.files[0]?.size > 1572864) {
                                setImageParceiro2(null);
                                setImageParceiro2Bool(false);
                                toast.error(
                                  'Imagem deve conter tamanho máximo de 1,5MB'
                                );
                              } else {
                                setImageParceiro2(e.target.files[0]);
                                setImageParceiro2Bool(true);
                              }
                            }}
                          />
                        )}
                        <label for='imagem_parceiro_2'></label>
                      </div>
                      <Label
                        style={{ color: 'green' }}
                        hidden={!imageParceiro2Bool}
                      >
                        Selecionado
                      </Label>
                    </div>
                    <div class='avatar-upload-3'>
                      <div class='avatar-edit mb-2'>
                        {imageParceiro3 && !imgId3?.edited ? (
                          <Button
                            color='danger'
                            className='btn-pill btn-block mt-1'
                            onClick={() => deleteImage(imgId3)}
                          >
                            Excluir imagem
                          </Button>
                        ) : (
                          <input
                            type='file'
                            id='imagem_parceiro_3'
                            accept='.png, .jpg, .jpeg'
                            onChange={(e) => {
                              if (e.target.files[0]?.size > 1572864) {
                                setImageParceiro3(null);
                                setImageParceiro3Bool(false);
                                toast.error(
                                  'Imagem deve conter tamanho máximo de 1,5MB'
                                );
                              } else {
                                setImageParceiro3(e.target.files[0]);
                                setImageParceiro3Bool(true);
                              }
                            }}
                          />
                        )}
                        <label for='imagem_parceiro_3'></label>
                      </div>
                      <Label
                        style={{ color: 'green' }}
                        hidden={!imageParceiro3Bool}
                      >
                        Selecionado
                      </Label>
                    </div>
                  </Row>
                </Col>
              </Row>
              <Row>
                <Col lg={6}>
                  <span className='placholder-top'>Marca</span>
                  <AsyncSelect
                    isDisabled={disabled}
                    loadOptions={(value) =>
                      debounceConsulta({
                        value,
                        param: 'nome',
                      })
                    }
                    name='marca'
                    marca={true}
                    getOptionLabel={(option) => option.nome}
                    onChange={setMarcaParceiro}
                    value={marcaParceiro}
                    cacheOptions
                    isClearable
                    error={erroMarca}
                    placeholder={'Busque pela marca'}
                    noOptionsMessage={() => 'Digite a marca'}
                    defaultValue={''}
                  />
                  {erroMarca && <small className='error'>Obrigatório</small>}
                </Col>
                <Col lg={6}>
                  <span className='placholder-top'>Descrição</span>
                  <InputUnform
                    placeholder=''
                    type='text'
                    name='descricao'
                    className='input-field-inner'
                    disabled={disabled}
                    defaultValue={
                      cliente && (cliente.descricao ? cliente.descricao : '')
                    }
                  />
                </Col>
              </Row>
              <Row>
                <Col lg={6}>
                  <span className='placholder-top'>Subtítulo</span>
                  <InputUnform
                    placeholder=''
                    type='text'
                    name='subtitulo'
                    className='input-field-inner'
                    disabled={disabled}
                    defaultValue={
                      cliente && (cliente.subtitulo ? cliente.subtitulo : '')
                    }
                  />
                </Col>
                <Col lg={6}>
                  <span className='placholder-top'>Benefício</span>
                  <InputUnform
                    placeholder=''
                    type='text'
                    name='beneficio'
                    className='input-field-inner'
                    disabled={disabled}
                    defaultValue={
                      cliente && (cliente.beneficio ? cliente.beneficio : '')
                    }
                  />
                </Col>

                <Col lg={12}>
                  <span className='placholder-top'>Regras de utilização</span>
                  <SunEditor
                    type='text'
                    name='regras_utilizacao'
                    className='input-field-inner-textarea w-100'
                    disabled={disabled}
                    defaultValue={
                      cliente &&
                      (cliente.regras_utilizacao
                        ? cliente.regras_utilizacao
                        : '')
                    }
                  />
                </Col>
                <Col lg={12}>
                  <span className='placholder-top'>
                    Sobre o estabelecimento
                  </span>
                  <SunEditor
                    type='text'
                    name='sobre_estabelecimento'
                    className='input-field-inner-textarea w-100'
                    disabled={disabled}
                    defaultValue={
                      cliente &&
                      (cliente.sobre_estabelecimento
                        ? cliente.sobre_estabelecimento
                        : '')
                    }
                  />
                </Col>
              </Row>
            </>
          )}
          <Row className='mt-20'>
            <Col className='justify-end'>
              <Button
                color='green'
                className='btn-save mb-1 bold'
                disabled={disabled}
              >
                Alterar dados
              </Button>
            </Col>
          </Row>
        </Form>
      </div>
    </>
  );
}

export default AlterarDadosAdm;

function SunEditor({ name, ...rest }) {
  const suneditorRef = useRef(null);
  const { fieldName, defaultValue, registerField, error } = useField(name);

  const buttonList = [
    ['undo', 'redo', 'font', 'fontSize', 'formatBlock'],
    [
      'blockquote',
      'bold',
      'underline',
      'italic',
      'strike',
      'fontColor',
      'hiliteColor',
      'removeFormat',
      'textStyle',
    ],
    [
      'outdent',
      'indent',
      'align',
      'list',
      'lineHeight',
      'paragraphStyle',
      'blockquote',
    ],
    ['link', 'fullScreen'],
  ];

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: suneditorRef.current,
      path: 'editor',
      getValue: (ref) => ref.editor.getContents(),
      setValue: (ref, value) => ref.editor.setContents(value),
    });
  }, [fieldName, registerField]);

  return (
    <>
      <SunEditorComponent
        ref={suneditorRef}
        id={fieldName}
        defaultValue={defaultValue}
        setOptions={{
          height: '100%',
          buttonList: buttonList,
          font: [
            'Arial',
            'Heebo',
            'tohoma',
            'Courier New,Courier',
            'Verdana',
            'Georgia',
          ],
        }}
        {...rest}
      />

      {error && <small className='error'>{error}</small>}
    </>
  );
}
